import React from 'react';
import { ApplicationPage } from '../../components/applications/ApplicationPage';
import { civilSocietyPage } from '../../data/applicationPages';
export function CivilSocietyPage() {
  return <ApplicationPage content={civilSocietyPage} data-id="element-1910" data-mp="3hfuw5swt5v1i" />;
}